// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__DPg0j","row":"styles_row__2_2do"};